/* eslint-disable max-lines */
const BankAccountDetails = () =>
    import(/* webpackChunkName: "IntervenerDetailRelated" */ '@/views/accounts/accounts-details/account-bank-accounts/bank-account-details');

export default {
    name: 'AccountBankAccounts',
    components: {
        BankAccountDetails
    },
    /**
     * @override
     */
    data() {
        return {
            bankAccounts: [],
            showForm: false,
            fields: [
                {
                    key: 'account_number',
                    label: 'Número de cuenta'
                },
                {
                    key: 'iban_code',
                    label: 'Código IBAN'
                },
                {
                    key: 'swift_code',
                    label: 'Código SWIFT o BIC'
                },
                {
                    class: 'actions',
                    key: 'actions',
                    label: ''
                }
            ],
            pendingDocuments: false
        };
    },
    props: {
        uuid: {
            type: String,
            required: false
        }
    },
    methods: {
        /**
         * Obtenemos la información del interviniente
         */
        fetchData() {
            this.uuid_account = this.uuid || this.$route.params.uuid;
            this.loadAccountBankAccounts(this.uuid_account);
        },
        /**
         * Obtenemos las cuentas bancarias de la cuenta
         * @param {String} uuid ID del interviniente
         */
        loadAccountBankAccounts(uuid) {
            this.$accountsService
                .getAccountBankAccounts(uuid, {})
                .then(res => {
                    this.bankAccounts = res.data.bank_accounts;
                    if (this.bankAccounts.find(ba => !ba.is_validated)) {
                        this.pendingDocuments = true;
                    } else {
                        this.pendingDocuments = false;
                    }
                })
                .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
        },
        /**
         * Mostramos el formulario para añadir una nueva cuenta bancaria
         */
        toggleForm() {
            this.showForm = !this.showForm;
        },
        /**
         * Creates a bank account
         * @param {Object} bankAccountData Datos de la cuenta bancaria
         */
        createBankAccount(bankAccountData) {
            this.$accountsService
                .createBankAccount(this.uuid, bankAccountData)
                .then(() => {
                    this.$toast.success(`201`, `La cuenta bancaria ha sido creada con éxito.`);
                    this.fetchData();
                    this.$root.$emit('refresh_account');
                })
                .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
        },
        /**
         * Updates a bank account
         * @param {Object} updatedBankAccountData Datos actualizados de la cuenta bancaria
         */
        updateBankAccount(updatedBankAccountData) {
            this.$accountsService
                .updateBankAccount(this.uuid, updatedBankAccountData)
                .then(() => {
                    this.$toast.success(`200`, `La cuenta bancaria ha sido actualizada con éxito.`);
                    this.fetchData();
                    this.$root.$emit('refresh_account');
                })
                .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
        },
        /**
         * Deletes a bank account
         * @param {Object} bankAccountUuid Uuid de la cuenta bancaria
         */
        deleteBankAccount(bankAccountUuid) {
            this.$accountsService
                .deleteBankAccount(this.uuid, bankAccountUuid)
                .then(() => {
                    this.$toast.success(`200`, `La cuenta bancaria ha sido borrada con éxito.`);
                    this.fetchData();
                    this.$root.$emit('refresh_account');
                })
                .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
        }
    },
    /**
     * @override
     */
    beforeMount() {
        this.fetchData();
    }
};
